import React, {useEffect, useState} from "react";
import Box from "./Box";
import RectangleCountdownTimer from "./RectangleCountdownTimer";
import {message} from "antd";
import axios from "axios";

const BASE_URL = process.env.REACT_APP_API_BASE_URL;

const ImageClickableOnlyOnLowerHalf = ({src, onClick, className}) => {
    const [cursorStyle, setCursorStyle] = useState('default');

    const handleClick = (event) => {
        const {clientX, clientY, target} = event;
        const {top, left, width, height} = target.getBoundingClientRect();

        const lowerBoundary = top + height * 0.8;
        const leftBoundary = left + (width * 0.25);
        const rightBoundary = left + (width * 0.75);

        if (clientY > lowerBoundary && clientX >= leftBoundary && clientX <= rightBoundary) {
            onClick(event);
        }
    };

    const handleMouseMove = (event) => {
        const {clientX, clientY, target} = event;
        const {top, left, width, height} = target.getBoundingClientRect();
        const lowerBoundary = top + height * 0.8;
        const leftBoundary = left + (width * 0.25);
        const rightBoundary = left + (width * 0.75);
        if (clientY > lowerBoundary && clientX >= leftBoundary && clientX <= rightBoundary) {
            setCursorStyle('pointer');
        } else{
            setCursorStyle('default');
        }
    }

    return (<div style={{position: "relative", cursor: cursorStyle}} className={className} onMouseMove={handleMouseMove}>
        <img src={src} alt="Clickable" onClick={handleClick} style={{width: '100%', height: 'auto'}}/>
    </div>)
}

const PreviousMonthTransactions = ({previousMonthCounts}) => {
    const existingMonths = previousMonthCounts.filter(month => month !== undefined && month !== null) || [];

    const getWidthClass = (index) => {
        if (index === 0) return 'w-full';
        const remainingCount = existingMonths.length - 1;
        switch (remainingCount) {
            case 1:
                return 'w-full text-2xl font-semibold flex justify-between';
            case 2:
                return 'w-[48.5%] text-xl font-medium flex flex-col';
            case 3:
                return 'w-[31.5%] text-lg font-medium flex flex-col';
            default:
                return 'hidden';
        }
    };

    return (<div className="w-full">
        <br/>
        {existingMonths.length > 0 ? (<div className={`flex flex-wrap justify-between w-full`}>
            {existingMonths.map((month, index) => (<div key={index}
                                                        className={`${getWidthClass(index)} ${index === 0 ? 'flex justify-between text-2xl font-semibold' : 'mt-2'} border-b-2 border-[#0044FF] bg-[#DAE1FF] text-[#0044FF] shadow-md shadow-blue-400  p-3 rounded-md`}>
                            <span>
                                {month.date.getMonth() + 1}-р сар
                            </span>
                <span>
                             {month.txnCount} ш
                            </span>
            </div>))}
        </div>) : (<div
            className={"flex justify-center items-center text-[3rem] gradient-text mt-2.5 mobile:text-[2rem]"}>МЭДЭЭЛЭЛ
            ОЛДСОНГҮЙ</div>)}
    </div>);
}

const DashBoardBodyApple = ({fiveMonthInfo, winnerInfo, items, currentLastPlace}) => {
    const [loterryCount, setLoterryCount] = useState(0);
    const [previousMonthCounts, setPreviousMonthCounts] = useState([]);
    const [isModalOpen, setIsModalOpen] = useState(false);
    const [isPrizeApproved, setIsPrizeApproved] = useState(false);
    const prizeDates = {
        phase1: {lowerBound: new Date('2025/01/10'), higherBound: new Date('2025/02/01')},
        phase2: {lowerBound: new Date('2025/02/15'), higherBound: new Date('2025/03/01')},
        phase3: {lowerBound: new Date('2025/03/14'), higherBound: new Date('2025/04/01')},
        phase4: {lowerBound: new Date('2025/04/15'), higherBound: new Date('2025/05/01')},
        phase5: {lowerBound: new Date('2025/05/15'), higherBound: new Date('2025/06/01')},
        phase6: {lowerBound: new Date('2025/06/15'), higherBound: new Date('2025/07/01')},
        phase7: {lowerBound: new Date("2025/07/15"), higherBound: new Date("2025/08/01")},
        phase8: {lowerBound: new Date("2025/08/15"), higherBound: new Date("2025/09/01")},
        phase9: {lowerBound: new Date("2025/09/15"), higherBound: new Date("2025/10/01")},
    }

    useEffect(() => {
        console.log(fiveMonthInfo);
        document.title = "Apple Pay";
        setLoterryCount(fiveMonthInfo === undefined || fiveMonthInfo == null ? 0 : fiveMonthInfo[0].txnCount);
        let prevMonthCounts = [];
        if (fiveMonthInfo !== undefined && fiveMonthInfo != null) {
            for (let i = 1; i < fiveMonthInfo.length; i++) {
                let date = fiveMonthInfo[i].yearMonth + "/01";
                prevMonthCounts.push({
                    date: new Date(date), txnCount: fiveMonthInfo[i].txnCount,
                });
            }

            setPreviousMonthCounts(prevMonthCounts);
        }

    }, []);

    const handleImageClick = async (event) => {
        event.stopPropagation();
        setIsModalOpen(false);
        if (!isPrizeApproved && winnerInfo.prizeType !== "noPrize") {
            try {
                const response = await axios.post(`${BASE_URL}/happypay/campaigns/apple-pay-cust.php/confirm`, items,{
                    headers: {
                        "Content-Type": "application/json",
                    }
                });

                if (response.status === 200) {
                    setIsPrizeApproved(true);
                    message.info("Таны шагнал баталгаажлаа.");
                }
            } catch (error) {
                message.error(error.message)
            }
        } else {
            if (isPrizeApproved) {
                message.warning("Таны шагнал баталгаажсан байна");
            }
        }
    }
    const viewPrize = () => {
        const today = new Date();
        let currentPhase = null;
        for (const [phase, {lowerBound, higherBound}] of Object.entries(prizeDates)) {
            if (today >= lowerBound && today <= higherBound) {
                currentPhase = phase;
                break;
            }
        }
        if (currentPhase === null) {
            message.info("Өмнөх сарын тохирол болоогүй байна.");
        }
        else{
            setIsModalOpen(true);
        }
    }

    function getNextPhaseLowerBound() {
        const currentDate = new Date();
        let nextPhase = null;
        let nextDate = null;

        for (const phase in prizeDates) {
            const { lowerBound, higherBound } = prizeDates[phase];

            if (currentDate.getTime() === lowerBound.getTime()) {
                return lowerBound;
            }

            if (lowerBound > currentDate) {
                if (!nextDate || lowerBound < nextDate) {
                    nextDate = lowerBound;
                    nextPhase = phase;
                }
            }
        }

        return nextDate;
    }


    return (<div id="body" className="flex flex-row w-full h-[87%] justify-between space-x-5">
        <div id="content" className="flex flex-col h-full w-2/3 space-y-5 mobile:w-full tablet:w-full">
            <div
                className="flex flex-row w-full h-1/2 space-x-5 mobile:flex-col tablet:flex-col tablet:space-x-0 tablet:space-y-5 mobile:space-x-0 mobile:space-y-5">
                <Box
                    style="p-10 w-1/2 h-full overflow-hidden bg-white flex flex-col justify-start  tablet:w-full tablet:h-1/2  items-center mobile:w-full mobile:h-1/2 ">
                    <p className='uppercase text-[#0987F3] font-semibold text-xl'>энэ сард Apple Pay-р хийсэн
                        гүйлгээ</p>
                    <div
                        className='flex flex-row justify-center gap-3 items-center w-[75%] tablet:p-8  mobile:p-5 h-full'>
                        {/*<img className="h-10 mobile:h-8 opacity-70" src="./icons/telegram-500.png" alt=""/>*/}
                        <p className='font-bold text-5xl mobile:text-4xl gradient-text'>{loterryCount} ширхэг</p>
                    </div>
                    <span className='font-light text-md text-[#0987F3]'>Өнөөдрийн байдлаар та <span className="font-bold text-lg">{currentLastPlace}</span>-с дээш гүйлгээ хийснээр урамшуулалт байранд шалгарах боломжтой байна.</span>
                </Box>
                <Box
                    style="p-10 w-1/2 h-full bg-white flex flex-col overflow-hidden justify-start items-center  tablet:w-full tablet:h-1/2 mobile:w-full mobile:h-1/2">
                    <p className='uppercase text-[#0987F3] font-semibold text-xl'>УРАМШУУЛАЛ</p>
                    <div className={"w-full h-full flex flex-col justify-center items-center"}>
                        <div className='flex flex-row gap-5 shadow-md shadow-blue-400 justify-center border border-[#0044FF]
                                     text-[#0044FF] bg-[#DAE1FF] font-semibold rounded-[12px] cursor-pointer
                                      mobile:h-16 mobile:mt-3 mobile:mb-3 items-center w-[75%] h-20 mobile:p-5
                                      hover:bg-[#AEB6FF] hover:text-[#F2F5FF] hover:shadow-cyan-500'
                             onClick={viewPrize}>
                            <img src="./icons/gift-50.png" className={"w-[10%] tablet:w-[8%]"} alt="Gift"/>
                            <span>УРАМШУУЛАЛ ШАЛГАХ</span>
                        </div>
                    </div>

                </Box>
            </div>
            <div
                className="flex flex-row w-full h-1/2 space-x-5 mobile:flex-col mobile:space-x-0 mobile:space-y-5 tablet:flex-col tablet:space-x-0 tablet:space-y-5">
                <Box
                    style="p-10 w-1/2 h-full bg-white overflow-hidden flex flex-col justify-start items-center tablet:w-full tablet:h-1/2 mobile:w-full mobile:h-1/2">
                    <p className='uppercase text-[#0987F3] font-semibold text-xl'>өмнөх саруудын гүйлгээ</p>
                    <PreviousMonthTransactions previousMonthCounts={previousMonthCounts}/>
                </Box>
                <Box
                    style="p-10 w-1/2 h-full overflow-hidden bg-white flex flex-col justify-start items-center tablet:w-full tablet:h-1/2 mobile:w-full mobile:h-1/2">
                    <p className='uppercase text-[#0987F3] font-semibold text-xl'>дараагийн шалгаруулалт</p>
                    <RectangleCountdownTimer targetDate={getNextPhaseLowerBound()} marginTop={'30px'}/>
                </Box>
            </div>
        </div>
        <div id="image" className="w-1/3 h-full rounded-lg mobile:hidden tablet:hidden">
            <img src="./apple_pay/june-update/apple-dash.jpg" alt="" className="h-full w-full object-cover rounded-lg"/>
        </div>

        {isModalOpen && (
            <div
                className={"w-screen h-screen absolute top-0 left- right-0 bottom-0 z-10"}>
                <div className={"w-screen h-screen bg-black opacity-60 bg-cover bg-no-repeat"} onClick={() => setIsModalOpen(false)}>
                </div>
                <div className={"absolute top-[10%] rounded-[20px] left-[15%] max-h-[90vh] w-[70%] " +
                    "mobile-Merchant:w-[90%] mobile-Merchant:top-[5%] mobile-Merchant:left-[5%] tablet-Merchant:w-[70%] tablet-Merchant:top-[2.5%] tablet-Merchant:left-[15%]"}
                    onClick={(event) => event.stopPropagation()}>
                >
                    <div className="mobile:hidden tablet:hidden w-full h-full">
                        {winnerInfo.prizeType !== 'noPrize' ? (
                            <ImageClickableOnlyOnLowerHalf
                                src={`./apple_pay/june-update/prize/${winnerInfo.prizeType}.jpg`}
                                onClick={handleImageClick}
                                className="rounded-[20px] object-contain w-full h-full max-h-[70vh]"
                            />
                        ) : (
                            <img
                                src={`./apple_pay/june-update/prize/${winnerInfo.prizeType}.jpg`}
                                onClick={handleImageClick}
                                className="rounded-[20px] object-contain w-full h-full max-h-[70vh]"
                                alt="Clickable"
                            />
                        )}
                    </div>
                    <div className="mobile:flex tablet:flex hidden w-full h-full">
                        {winnerInfo.prizeType !== 'noPrize' ? (
                            <ImageClickableOnlyOnLowerHalf
                                src={`./apple_pay/june-update/prize/${winnerInfo.prizeType}-mobile.jpg`}
                                onClick={handleImageClick}
                                className="rounded-[20px] object-cover max-h-[80vh] max-w-full"
                            />
                        ) : (
                            <img
                                src={`./apple_pay/june-update/prize/${winnerInfo.prizeType}-mobile.jpg`}
                                onClick={handleImageClick}
                                className="rounded-[20px] object-cover max-h-[80vh] max-w-full"
                                alt="Clickable"
                            />
                        )}
                    </div>
                </div>
            </div>
        )}
    </div>)
}

export default DashBoardBodyApple;